<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <HeroForm :baseHero="hero" :baseheroName="name" :loading="loading" @submit-requested="submitRequested"></HeroForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import HeroForm from './HeroForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                hero: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { HeroForm },
        computed:
        {
            ...mapState('hero', ['getHeroByIdOutput']),
        },
        methods: {
            ...mapActions('hero', ['getHeroById']),
            ...mapActions('hero', ['putHero']),
            submitRequested(hero) {
                this.putHero(hero);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "Hero"});
            }
            else {
                this.getHeroById(this.$route.query.id);
            }
        },
        watch:
        {
            getHeroByIdOutput: function (output) {
                if (!output) {
                    router.push({name: "Hero"});
                }
                else {
                    this.hero = output;
                    this.loading = false;
                }
            }
        }
    }
</script>